import { useEffect, useState } from 'react'

/**
 * «Сегодня» для экранов, которые живут дольше суток (календарь на открытой вкладке).
 * Одна и та же Date в пределах дня (стабильная ссылка — производное не пересчитывается
 * на чужих ре-рендерах), в полночь — новая. Таймер до следующей полуночи перезаводится
 * после каждого перехода; заснувший на native таймер сработает при пробуждении.
 */
export function useToday(): Date {
  const [today, setToday] = useState(() => new Date())
  useEffect(() => {
    const midnight = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1)
    const t = setTimeout(() => setToday(new Date()), midnight.getTime() - Date.now() + 500)
    return () => clearTimeout(t)
  }, [today])
  return today
}
